import listaInmuebles from '@/pages/incrustado/listaInmuebles'
import condiciones from '@/pages/incrustado/condiciones'
import registro from '@/pages/incrustado/registro'
import scoring from '@/pages/incrustado/scoring'

import stepper from '@/pages/incrustado/stepper'
import mensajeError from '@/pages/incrustado/mensajeError'
import mensajeReservado from '@/pages/incrustado/mensajeReservado'
import mensajeConfirmar from '@/pages/incrustado/mensajeConfirmar'

const defaultMeta = {}

const routes = [
  {
    path: '/incrustado/listaInmuebles',
    component: listaInmuebles,
    name: 'incrustado.listaInmuebles'
  },
  {
    path: '/incrustado/listaInmueblesAlquiler',
    component: listaInmuebles,
    name: 'incrustado.listaInmueblesAlquiler'
  },
  {
    path: '/incrustado/condiciones',
    component: condiciones,
    name: 'incrustado.condiciones'
  },
  {
    path: '/incrustado/scoring/:codigoPromocion/:simplificada',
    component: scoring,
    name: 'incrustado.scoring',
    props: true
  },
  {
    path: '/incrustado/condicionesAlquiler',
    component: condiciones,
    name: 'incrustado.condicionesAlquiler'
  },
  {
    path: '/incrustado/registro',
    component: registro,
    name: 'incrustado.registro'
  },
  {
    path: '/incrustado/confirmar/:actorId/:token',
    component: mensajeConfirmar,
    name: 'incrustado.confirmar',
    props: true
  },
  {
    path: '/incrustado/stepper',
    component: stepper,
    name: 'incrustado.stepper',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/incrustado/mensajeError',
    component: mensajeError,
    name: 'incrustado.mensajeError'
  },
  {
    path: '/incrustado/mensajeReservado/:reservaUsuario',
    props: true,
    component: mensajeReservado,
    name: 'incrustado.mensajeReservado'
  }
].map(r => {
  return {
    ...r,
    meta: Object.assign({}, defaultMeta, r.meta)
  }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/incrustado.js